import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { CountryState } from "../../../types";
import { axiosObj } from "../../../../config/apiClients";
import { Country } from "../../../../utils/types";

const initialState: CountryState = {
  isLoading: false,
  countries: []
}

export const getAllCountries = createAsyncThunk(
  "/countries/getAll",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axiosObj.get('/countries/getAll');
      return response.data;
    } catch (error) {
      return rejectWithValue(error || { message: 'Failed to Fetch Countries List' });
    }
  }
);

export const createCountry = createAsyncThunk(
  "/countries/create",
  async (county: Country, { rejectWithValue }) => {
    try {
      const response = await axiosObj.post('/countries/create', county);
      return response.data;
    } catch (error) {
      return rejectWithValue(error || { message: 'Failed to Add Country' });
    }
  }
)

export const updateCountry = createAsyncThunk(
  "/countries/update",
  async (country: Country, { rejectWithValue }) => {
    try {
      const response = await axiosObj.patch('/countries/update', { ...country, id: country._id });
      return response.data;
    } catch (error) {
      return rejectWithValue(error || { message: 'Failed to Update Country' });
    }
  }
)

export const deleteCountry = createAsyncThunk(
  "/countries/delete",
  async (countryId: string, { rejectWithValue }) => {
    try {
      const response = await axiosObj.delete('/countries/delete', { data: { countryId } });
      return response.data;
    } catch (error) {
      return rejectWithValue(error || { message: 'Failed to Delete Country' });
    }
  }
)

export const importCountries = createAsyncThunk(
  "/countries/seed",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axiosObj.post('/countries/seed');
      return response.data;
    } catch (error) {
      return rejectWithValue(error || { message: 'Failed to Import Countries data' });
    }
  }
)

const countrySlice = createSlice({
  name: "country",
  initialState,
  reducers: {
    updateCountryItem: (state, action) => {
      const index = state.countries.findIndex((team) => team._id === action.payload._id);
      if (index !== -1) {
        state.countries[index] = action.payload;
      }
    },
    deleteCountryItem: (state, action) => {
      state.countries = state.countries.filter((item) => item._id !== action.payload);
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAllCountries.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getAllCountries.fulfilled, (state, action) => {
        state.isLoading = false;
        state.countries = action.payload.payload;
      })
      .addCase(getAllCountries.rejected, (state) => {
        state.isLoading = false;
        state.countries = [];
      })
      .addCase(createCountry.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(createCountry.fulfilled, (state) => {
        state.isLoading = false;
      })
      .addCase(createCountry.rejected, (state) => {
        state.isLoading = false;
      })
      .addCase(updateCountry.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(updateCountry.fulfilled, (state) => {
        state.isLoading = false;
      })
      .addCase(updateCountry.rejected, (state) => {
        state.isLoading = false;
      })
      .addCase(deleteCountry.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(deleteCountry.fulfilled, (state) => {
        state.isLoading = false;
      })
      .addCase(deleteCountry.rejected, (state) => {
        state.isLoading = false;
      })
      .addCase(importCountries.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(importCountries.fulfilled, (state) => {
        state.isLoading = false;
      })
      .addCase(importCountries.rejected, (state) => {
        state.isLoading = false;
      });
  }
});

export const { updateCountryItem, deleteCountryItem } = countrySlice.actions;

export default countrySlice.reducer;